var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelTrainingGradient = function SvgModelTrainingGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 34 38"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "model_training_gradient_svg__a",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5DF2AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EAF67C"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#model_training_gradient_svg__a)",
    d: "M3.377 32.816a17 17 0 0 1-2.502-4.741Q0 25.504 0 22.615q0-7.114 4.943-12.057Q9.884 5.616 17 5.616h2.823l-4.238-4.239L16.962 0l6.615 6.616-6.616 6.615-1.426-1.427 4.188-4.188H17q-6.224 0-10.611 4.388Q2 16.393 2 22.616q0 2.472.748 4.704a14.8 14.8 0 0 0 2.095 4.069zM15.539 33q-.193-1.496-.91-2.64a34 34 0 0 0-1.513-2.215 19 19 0 0 1-1.418-2.204q-.621-1.133-.621-2.556 0-2.44 1.742-4.181T17 17.462q2.44 0 4.181 1.742 1.742 1.743 1.742 4.18 0 1.424-.621 2.538a22 22 0 0 1-1.418 2.203 38 38 0 0 0-1.513 2.235q-.717 1.144-.91 2.64zm.077 5v-2.23h2.768V38zm15.007-5.184-1.466-1.428a14.8 14.8 0 0 0 2.095-4.068Q32 25.088 32 22.616q0-3.224-1.24-6.03a14.7 14.7 0 0 0-3.449-4.859l1.427-1.427a16.9 16.9 0 0 1 3.87 5.486Q34 18.927 34 22.617q0 2.888-.875 5.459a17 17 0 0 1-2.502 4.74"
  })));
};
export default SvgModelTrainingGradient;